import * as React from 'react'
import ReactPlayer from 'react-player'
import { ShopifyNext } from '@dotdev/next-components'
import { GlobalProps } from 'types'
import * as Snippets from 'snippets'

export class DynamicImageLayers extends React.PureComponent<
  DynamicImageLayers.Props,
  DynamicImageLayers.State
> {
  public static sectionId = 'imagela';

  public render(): JSX.Element {
    const layers = this.props.section.blocks.map((block) => {
      return block.settings
    })
  
    return (
      <section className={'dynamic-image-layers'}>
        <div className="relative max-w-container mx-auto mt-2 mb-14-5">
          <div className="grid md:hidden relative grid-cols-12">
            {layers.map((layer, index) => {
              let mobileStyle = {
                gridRow: layer.mobilegridrowcss,
                gridColumn: layer.mobilegridcolumncss,
                paddingTop: layer.mobilepaddingtopcss,
                marginLeft: layer.mobilemarginleftcss,
                marginRight: layer.mobilemarginrightcss,
                zIndex: parseInt(layer.zindexcss),
              }          
              return (
                <div key={index} style={mobileStyle}>
                  <img src={layer.src} alt={layer.title} />
                </div>
              )
            })}
          </div>
          <div className="hidden md:grid relative grid-cols-12">
            {layers.map((layer, index) => {
              let style = {
                gridRow: layer.gridrowcss,
                gridColumn: layer.gridcolumncss,
                paddingTop: layer.paddingtopcss,
                marginLeft: layer.marginleftcss,
                marginRight: layer.marginrightcss,
                zIndex: parseInt(layer.zindexcss),
              }

              return (
                <div key={index} style={style}>
                  
                  <img src={layer.src} alt={layer.title} />
                </div>
              )
            })}
          </div>
        </div>
      </section>
    )
  }
}

export namespace DynamicImageLayers {
  export type Layer = {
    title: string;
    image: string;
    zindexcss: string;
    gridrowcss: string;
    gridcolumncss: string;
    paddingtopcss: string;
    marginleftcss: string;
    marginrightcss: string;
    mobilegridrowcss: string;
    mobilegridcolumncss: string;
    mobilepaddingtopcss: string;
    mobilemarginleftcss: string;
    mobilemarginrightcss: string;
  };
  export type Options = ShopifyNext.Section<{
    layers: Layer[];
  }>;
  export interface Props extends GlobalProps {
    section: DynamicImageLayers.Options;
  }
  export interface State {
    playing: boolean;
    alternateText: boolean;
  }
}

// const desktopSample = [
//   {
//     gridRow: "1",
//     gridColumn: "1 / span 3",
//     paddingTop: "10%",
//     marginLeft: undefined,
//     marginRight: undefined,
//     zIndex: undefined,
//   },
//   {
//     gridRow: "1",
//     gridColumn: "5 / span 4",
//     paddingTop: undefined,
//     marginLeft: undefined,
//     marginRight: undefined,
//     zIndex: "1",
//   },
//   {
//     gridRow: "1",
//     gridColumn: "9 / span 3",
//     paddingTop: "60%",
//     marginLeft: "24px",
//     marginRight: undefined,
//     zIndex: undefined,
//   },
//   {
//     gridRow: "1",
//     gridColumn: "3 / span 3",
//     paddingTop: "125%",
//     marginLeft: undefined,
//     marginRight: "50px",
//     zIndex: undefined,
//   },
//   {
//     gridRow: "1",
//     gridColumn: "6 / span 3",
//     paddingTop: "160%",
//     marginLeft: "50px",
//     marginRight: "24px",
//     zIndex: undefined,
//   },
// ];

// const mobileSample = [
//   {
//     gridRow: "1",
//     gridColumn: "1 / span 4",
//     paddingTop: undefined,
//     marginLeft: undefined,
//     marginRight: undefined,
//     zIndex: undefined,
//   },
//   {
//     gridRow: "1",
//     gridColumn: "3 / span 8",
//     paddingTop: "20%",
//     marginLeft: undefined,
//     marginRight: undefined,
//     zIndex: "1",
//   },
//   {
//     gridRow: "1",
//     gridColumn: "10 / span 3",
//     paddingTop: "400%",
//     marginLeft: undefined,
//     marginRight: undefined,
//     zIndex: undefined,
//   },
//   {
//     gridRow: "1",
//     gridColumn: "1 / span 5",
//     paddingTop: "180%",
//     marginLeft: undefined,
//     marginRight: undefined,
//     zIndex: undefined,
//   },
//   {
//     gridRow: "1",
//     gridColumn: "7 / span 4",
//     paddingTop: "260%",
//     marginLeft: undefined,
//     marginRight: "12px",
//     zIndex: undefined,
//   },
// ];
